import { permissions } from 'lib/roles/roles-config';
import { effectiveBillingRoles } from 'modules/iam';
import { useAppSelector } from './useAppSelector';

export default function usePermissions() {
  const selectedBillingRoles = useAppSelector(effectiveBillingRoles);

  const hasPermission = (permission: string) => {
    if (!selectedBillingRoles) return false;
    const availablePermission = permissions[permission];

    return availablePermission.some((access) => selectedBillingRoles.includes(access));
  };

  return { hasPermission };
}
